module.exports = __webpack_public_path__ + "img/logo-vertical.87268557.svg";